import { createStore, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import omit from 'lodash/omit';
import {persistReducer, createTransform} from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducer from '../reducers';

const blacklistTransform = createTransform(
  inboundState => omit(inboundState, 'isLoading', 'errors')
);

const persistConfig = {
  key: 'auth',
  storage,
  transforms: [blacklistTransform],
  whitelist: ['auth']
};

const middleware = [thunk];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;


const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(...middleware))
);



// WEBPACK FOOTER //
// ./src/store/index.js